import { authHeader } from "../../_helpers/auth-header";
import { appConfig, headerConfig, refineHeader } from "../../config";
import auth from "../auth";

export const countryCityService = {
  get_states,
  get_cities,
  get_countries,
  get_all_city,
  get_state,
  add_city_status,
  get_country_data,
  get_citydetails_ByState,
  getCities,
  getCountryCity,
  add_city_SoldOut,
  add_FB_Link
};

function get_all_city(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}city/list`, requestOptions)
    .then(handleResponse)
    .then(cities => {
      return cities.data;
    });
}

function get_countries() {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(`${appConfig.api.url}public-city/all-country`, requestOptions)
    .then(handleResponse)
    .then(countries => {
      return countries;
    });
}

function get_country_data() {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(`${appConfig.api.url}public-city/country`, requestOptions)
    .then(handleResponse)
    .then(countries => {
      return countries;
    });
}
function get_state(countryNameParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(
    `${appConfig.api.url}public-city/state/${countryNameParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(states => {
      return states;
    });
}

function get_states(countryNameParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(
    `${appConfig.api.url}public-city/all-state/${countryNameParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(states => {
      return states;
    });
}

function get_citydetails_ByState(stateAbbr) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(`${appConfig.api.url}public-city/${stateAbbr}`, requestOptions)
    .then(handleResponse)
    .then(cityDetailsByState => {
      return cityDetailsByState;
    });
}

  function get_cities(stateAbbr) {
    refineHeader();
    const requestOptions = {
      method: "GET",
      headers: headerConfig.headerDatas,
      mode: "cors",
      // body: JSON.stringify()
    };

    return fetch(`${appConfig.api.url}public-city/all-city/${stateAbbr}`, requestOptions)
      .then(handleResponse)
      .then(cityDetailsByState => {
        return cityDetailsByState;
      });
  }


function getCities() {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(`${appConfig.api.url}activeCities`, requestOptions)
    .then(handleResponse)
    .then(cities => {
      return cities.data;
    });
}

function add_city_status(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}city/cityStatus`, requestOptions)
    .then(handleResponse)
    .then(propsData => {
      return propsData;
    });
}
function getCountryCity(countryName) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(`${appConfig.api.url}public-city/country/${countryName}`, requestOptions)
    .then(handleResponse)
    .then(countries => {
      return countries;
    });
}
function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

function add_city_SoldOut(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}city/sold_out`, requestOptions)
    .then(handleResponse)
    .then(propsData => {
      return propsData;
    });
}

function add_FB_Link(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}city/cityFBLink`, requestOptions)
    .then(handleResponse)
    .then(propsData => {
      return propsData;
    });
}



// WEBPACK FOOTER //
// ./src/app/services/API/countryCityService.js